import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
import { isRichContent, toPlainText } from '../../../services/rich-content';
function isCheckbox(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.CHECKBOX && isRichContent(label) && (typeof value === 'boolean' || value === null);
}
function _formatCheckbox(_ref) {
  let {
    field,
    value
  } = _ref;
  if (typeof value !== 'boolean' || value === false) {
    return;
  }
  const label = toPlainText(field.view.label);
  return {
    label,
    value
  };
}
export function formatCheckbox(submission) {
  if (isCheckbox(submission)) {
    return _formatCheckbox(submission);
  }
  return undefined;
}
//# sourceMappingURL=checkbox-preview.js.map